import React from 'react'
import PropTypes from 'prop-types'
import { GridWrapper, ErrorTypography } from './ContractDivisionNoInfo.styles'

const ContractDivisionNoInfo = ({ errorText }) => {
  return (
    <GridWrapper container className="error__container">
      <ErrorTypography variant="body1" color="black1" className="error__description">
        {errorText}
      </ErrorTypography>
    </GridWrapper>
  )
}

ContractDivisionNoInfo.propTypes = {
  errorText: PropTypes.string.isRequired
}

export default ContractDivisionNoInfo
